export const states = [
  { description: 'Acre', value: 'AC' },
  { description: 'Maranhão', value: 'MA' },
  { description: 'Rio de Janeiro', value: 'RJ' },
  { description: 'Alagoas', value: 'AL' },
  { description: 'Mato Grosso', value: 'MT' },
  { description: 'Rio Grande do Norte', value: 'RN' },
  { description: 'Amapá', value: 'AP' },
  { description: 'Mato Grosso do Sul', value: 'MS' },
  { description: 'Rio Grande do Sul', value: 'RS' },
  { description: 'Amazonas', value: 'AM' },
  { description: 'Minas Gerais', value: 'MG' },
  { description: 'Rôndonia', value: 'RO' },
  { description: 'Bahia', value: 'BA' },
  { description: 'Pará', value: 'PA' },
  { description: 'Roraima', value: 'RR' },
  { description: 'Ceará', value: 'CE' },
  { description: 'Paraíba', value: 'PB' },
  { description: 'Santa Catarina', value: 'SC' },
  { description: 'Distrito Federal', value: 'DF' },
  { description: 'Paraná', value: 'PR' },
  { description: 'São Paulo', value: 'SP' },
  { description: 'Espírito Santo', value: 'ES' },
  { description: 'Pernambuco', value: 'PE' },
  { description: 'Sergipe', value: 'SE' },
  { description: 'Goiás', value: 'GO' },
  { description: 'Piauí', value: 'PI' },
  { description: 'Tocantins', value: 'TO' },
];

export const addressTypes = [
  {
    value: 0,
    description: 'PERSON.ADDRESSES.TYPE.COMMERCIAL',
  },
  {
    value: 1,
    description: 'PERSON.ADDRESSES.TYPE.RESIDENTIAL',
  },
  {
    value: 2,
    description: 'PERSON.ADDRESSES.TYPE.OTHER',
  },
];
